import { createFileRoute } from '@tanstack/react-router'
import { ApprovalRequestPage } from '../../../features/approvals/request-page'
import { approvalRequestSearchSchema } from '../../../features/approvals/search'

export const Route = createFileRoute('/_app/approvals/$runId')({
  staticData: { crumb: 'approvalRequest' },
  validateSearch: approvalRequestSearchSchema,
  component: ApprovalRequestPage,
})
